/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * An enumeration.
 */
export var MEMO;
(function (MEMO) {
    MEMO["AR_ADJUSTMENT"] = "ar_adjustment";
    MEMO["COMMISSION"] = "commission";
    MEMO["CHARGEBACK"] = "chargeback";
    MEMO["REVERSAL"] = "reversal";
    MEMO["MARKETING"] = "marketing";
    MEMO["MARKETING_AD_SPEND"] = "marketing_ad_spend";
    MEMO["MARKETING_PROMO"] = "marketing_promo";
    MEMO["UNACCOUNTED"] = "unaccounted";
    MEMO["MISC"] = "misc";
    MEMO["CUSTOMER_TIP"] = "customer_tip";
    MEMO["NET_PAYOUT"] = "net_payout";
    MEMO["SUBTOTAL"] = "subtotal";
    MEMO["TAX_HOST"] = "tax_host";
    MEMO["TAX_WITHELD"] = "tax_witheld";
    MEMO["TAX_WITHELD_REVERSED"] = "tax_witheld_reversed";
    MEMO["LOST_SALE"] = "lost_sale";
    MEMO["TAX_REVERSAL"] = "tax_reversal";
    MEMO["RESTAURANT_DELIVERY_CHARGE"] = "restaurant_delivery_charge";
    MEMO["LOYALTY"] = "loyalty";
    MEMO["RESTAURANT_FEES"] = "restaurant_fees";
    MEMO["POS_SUBTOTAL"] = "pos_subtotal";
    MEMO["POS_TAX"] = "pos_tax";
    MEMO["POS_COMMISSION"] = "pos_commission";
    MEMO["VARIANCE_POS_SUBTOTAL"] = "variance_pos_subtotal";
    MEMO["VARIANCE_POS_TAX"] = "variance_pos_tax";
    MEMO["VARIANCE_POS_COMMISSION"] = "variance_pos_commission";
})(MEMO || (MEMO = {}));
